<template>
  <div class="my-layout-box">
    <!-- 订单信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>订单信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>入仓单号：</span>
            <i class="c-code-color"> {{ items.Code }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>单据状态：</span>
            <i
              :class="
                items.Status === 0
                  ? 'c-one-color'
                  : items.Status === 1
                  ? 'c-two-color'
                  : 'c-four-color'
              "
            >
              {{ items.Status === 0 ? "待提交" : items.Status === 1 ? "待审核" : "已审核" }}</i
            >
          </li>
          <li>
            <span>出库时间:</span>
            <i> {{ items.BusinessDate | FormatDate }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 产品信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>产品信息</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>
      </section>
    </section>
    <!-- 仓库操作 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>仓库操作要求</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul" v-if="items.IsMeasureWeightRequired">
          <li>
            <span>测量磅重: </span>
            <i>{{ items.MeasureWeightRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsMeasureVolumeRequired">
          <li>
            <span>测量体积：</span>
            <i>{{ items.MeasureVolumeRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsCameraRequired">
          <li>
            <span>拍照：</span>
            <i>{{ items.CameraRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsHandleMarkRequired">
          <li>
            <span>处理标签：</span>
            <i>{{ items.HandleMarkRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsOtherRequired">
          <li>
            <span>其他需求：</span>
            <i>{{ items.OtherRequired }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 国内物流 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>货运信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>交货方式：</span>
            <i
              :class="
                items.StockOutType == 1
                  ? 'c-one-color'
                  : items.StockOutType == 2
                  ? 'c-two-color'
                  : 'c-four-color'
              "
              >{{
                items.StockOutType === 1
                  ? "BOM.AI送货"
                  : items.StockOutType === 2
                  ? "客户自提"
                  : items.StockOutType === 4
                  ? "快递"
                  : ""
              }}</i
            >
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>送货地址: </span>
            <i> {{ items.DeliveryAddress }}</i>
          </li>
        </ul>

        <div v-if="items.StockOutType === 2" style="margin-top: 5px">
          <ul class="c-content-ul">
            <li>
              <span>提货人:</span>
              <i>{{ items.PickGoodsPeople }}</i>
            </li>
            <li>
              <span>电话:</span>
              <i>{{ items.PeoplePhone }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>身份证/通行证号:</span>
              <i>{{ items.PeopleId }}</i>
            </li>
          </ul>
        </div>

        <div v-if="items.StockOutType !== 2" style="margin-top: 5px">
          <ul class="c-content-ul">
            <li>
              <span style="display: inline-block;width: 80px;">收货公司：</span>
              <i>{{ items.CompanyName }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>联系人: </span>
              <i>{{ items.AddressName }}</i>
            </li>
            <li>
              <span>联系电话: </span>
              <i>{{ items.AddressPhone }}</i>
            </li>
          </ul>
        </div>

        <div v-if="items.StockOutType === 4" style="margin-top: 5px">
          <ul class="c-content-ul">
            <li>
              <span>快递费支付:</span>
              <i>{{
                items.SendExpressPayType == 1
                  ? "到付"
                  : items.SendExpressPayType == 2
                  ? "寄付"
                  : items.SendExpressPayType == 3
                  ? "第三方付"
                  : ""
              }}</i>
            </li>
            <li>
              <span>第三方账户: </span>
              <i>{{ items.ThirdExpressAccount }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>快递公司: </span>
              <i>{{ items.ExpressName }}</i>
            </li>
          </ul>
          <ul class="c-content-ul" v-if="items.StockOutStatus == 1">
            <li>
              <span>快递单号:</span>
              <i>{{ items.ExpressNo }}</i>
            </li>
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { getHKStockDetail } from "~/api/order";
import { hkStockDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
export default {
  name: "hkOrderDetail",
  components: {
    DetailList
  },
  data() {
    return {
      items: {},
      listMap: hkStockDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        Id: id
      };
      let data = await getHKStockDetail(params);
      this.items = data;
      this.$refs.detailList.getList(data.StockOutLineResults);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
